import http from '@/util/http'

// 数据报表-仓储-实时库存   倒序
export function queryReportReal (page, size, data) {
  return http({
    url: `/api/storageBase/queryReportReal/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-实时库存 -导出
export function reportReal (data) {
  return http({
    url: '/api/storageBase/reportReal',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-仓储-仓库盈亏报表
export function queryReportProfitLoss (page, size, data) {
  return http({
    url: `/api/storageBase/queryReportProfitLoss/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-仓库盈亏报表 -导出
export function reportProfilLoss (data) {
  return http({
    url: '/api/storageBase/reportProfilLoss',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-仓储-库存汇总表
export function queryReportStorageCollect (page, size, data) {
  return http({
    url: `/api/storageBase/queryReportStorageCollect/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-库存汇总表-导出
export function exportReportStorageList (data) {
  return http({
    url: '/api/storageBase/exportReportStorageList',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-仓储-仓储备货报表
export function queryStorageStock (page, size, data) {
  return http({
    url: `/api/storageBase/queryStorageStock/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-仓储备货报表-导出
export function exportStorageStock (data) {
  return http({
    url: '/api/storageBase/exportStorageStock',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-仓储-仓库入库明细表
export function queryReportInStorage (page, size, data) {
  return http({
    url: `/api/storageBase/queryReportInStorage/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-仓库入库明细表-导出
export function reportInStorage (data) {
  return http({
    url: '/api/storageBase/reportInStorage',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-仓储-仓库出库明细表
export function queryReportOutStorage (page, size, data) {
  return http({
    url: `/api/storageBase/queryReportOutStorage/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-仓储-仓库出库明细表-导出
export function reportOutStorage (data) {
  return http({
    url: '/api/storageBase/reportOutStorage',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-付款汇总表
export function queryFinancePaySourceList (page, size, data) {
  return http({
    url: `/api/financePay/queryFinancePaySource/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-付款汇总表-导出
export function exportFinancePaySource (data) {
  return http({
    url: '/api/financePay/exportFinancePaySource',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-收款汇总表
export function collectionSummary (page, size, data) {
  return http({
    url: `/api/financeAcceptanceBillRequest/collectionSummary/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-收款汇总表-导出
export function reportCollectionSummary (data) {
  return http({
    url: '/api/financeAcceptanceBillRequest/reportCollectionSummary',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-应收汇总表
export function receivableSummary (page, size, data) {
  return http({
    url: `/api/customerAccountBase/receivableSummary/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-应收汇总表-导出
export function reportReceivableSummary (data) {
  return http({
    url: '/api/customerAccountBase/reportReceivableSummary',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-应收汇总表详情页
export function AccountsReceivableDetails (page, size, cusId, data) {
  return http({
    url: `/api/customerAccountBase/AccountsReceivableDetails/${page}/${size}/${cusId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-应收汇总表详情页-导出
export function reportAccountsReceivableDetails (cusId, data) {
  return http({
    url: `/api/customerAccountBase/reportAccountsReceivableDetails/${cusId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-应付汇总表
export function payableSummary (page, size, data) {
  return http({
    url: `/api/supplierAcountBase/payableSummary/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-应付汇总表-导出
export function reportPayableSummary (data) {
  return http({
    url: '/api/supplierAcountBase/reportPayableSummary',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-应付汇总表详情页
export function accountsPayableDetails (page, size, suId, data) {
  return http({
    url: `/api/supplierAcountBase/accountsPayableDetails/${page}/${size}/${suId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-应付汇总表详情页-导出
export function reportAccountsPayableDetail (suId, data) {
  return http({
    url: `/api/supplierAcountBase/reportAccountsPayableDetail/${suId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-红字发票退票汇总表
export function redLetterInvoiceRefundSummarySheet (page, size, data) {
  return http({
    url: `/api/orderContractInvoiceSub/redLetterInvoiceRefundSummarySheet/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-红字发票退票汇总表-导出
export function reportRedLetterInvoiceRefundSummarySheet (data) {
  return http({
    url: '/api/orderContractInvoiceSub/reportRedLetterInvoiceRefundSummarySheet',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-普通退票汇总表
export function generalRefundSummaryTable (page, size, data) {
  return http({
    url: `/api/orderContractInvoiceSub/generalRefundSummaryTable/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-普通退票汇总表-导出
export function reportGeneralRefundSummaryTable (data) {
  return http({
    url: '/api/orderContractInvoiceSub/reportGeneralRefundSummaryTable',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-红字发票退票汇总表详情页
export function refundDetails (page, size, type, id, data) {
  return http({
    url: `/api/orderContractInvoiceSub/refundDetails/${page}/${size}/${type}/${id}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-红字发票退票汇总表详情页-导出
export function reportRefundDetails (type, id, isRed, data) {
  return http({
    url: `/api/orderContractInvoiceSub/reportRefundDetails/${type}/${id}/${isRed}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-物流费用统计表
export function logisticsCostStatistics (page, size, data) {
  return http({
    url: `/api/financeLogistic/logisticsCostStatistics/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-物流费用统计表-导出
export function repostLogisticsCostStatistics (data) {
  return http({
    url: '/api/financeLogistic/repostLogisticsCostStatistics',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-物流费用统计表详情页
export function logisticsOrderDetails (id, data) {
  return http({
    url: `/api/financeLogistic/logisticsOrderDetails/${id}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-物流费用统计表详情页-导出
export function reportLogisticsOrderDetails (id, data) {
  return http({
    url: `/api/financeLogistic/reportLogisticsOrderDetails/${id}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-未开票汇总表
export function summaryOfUnbilledInvoices (page, size, data) {
  return http({
    url: `/api/orderContractInvoice/summaryOfUnbilledInvoices/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-未开票汇总表-导出
export function reportSummaryOfUnbilledInvoices (data) {
  return http({
    url: '/api/orderContractInvoice/reportSummaryOfUnbilledInvoices',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-未收票汇总表
export function summaryOfUncollectedInvoices (page, size, data) {
  return http({
    url: `/api/orderContractInvoice/summaryOfUncollectedInvoices/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-未收票汇总表-导出
export function reportSummaryOfUncollectedInvoices (data) {
  return http({
    url: '/api/orderContractInvoice/reportSummaryOfUncollectedInvoices',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-销售成本表
export function queryCostSales (page, size, data) {
  return http({
    url: `/api/financePay/queryCostSales/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-销售成本表-导出
export function exportCostSales (data) {
  return http({
    url: '/api/financePay/exportCostSales',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-贴现报表
export function queryFinanceDiscountBill (page, size, data) {
  return http({
    url: `/api/financePay/queryFinanceDiscountBill/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-提现报表-导出
export function exportFinanceDiscountBill (data) {
  return http({
    url: '/api/financePay/exportFinanceDiscountBill',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-未开票汇总表
export function querySupplierBaseAccountInvoiceList (page, size, data) {
  return http({
    url: `/api/customerBase/querySupplierBaseAccountInvoiceList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-未开票汇总表-导出

// 数据报表-财务-未收票汇总表
export function querySupplierBaseAccount (page, size, data) {
  return http({
    url: `/api/supplierBase/querySupplierBaseAccountInvoiceList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-未收票汇总表-导出

// 数据报表-财务-物流费用统计
export function queryFinanceLogisticList (page, size, data) {
  return http({
    url: `/api/financeLogistic/queryFinanceLogisticList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-物流费用统计-导出

// 数据报表-财务-开票汇总表
export function queryOpenInvoiceList (page, size, data) {
  return http({
    url: `/api/financePay/queryOpenInvoiceList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-开票汇总表-导出
export function exportQueryOpenInvoiceList (data) {
  return http({
    url: '/api/financePay/queryOpenInvoiceList',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-开票汇总表-详情页
export function queryBillingDetails (id, page, size, data) {
  return http({
    url: `/api/financePay/queryBillingDetails/${id}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-开票汇总表-详情页-导出
export function exportBillingDetails (id, data) {
  return http({
    url: `/api/financePay/exportBillingDetails/${id}`,
    method: 'get',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-收票汇总表
export function invoiceSummary (page, size, data) {
  return http({
    url: `/api/purchaseContractInvocie/invoiceSummary/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-收票汇总表-导出
export function reportInvoiceSummary (data) {
  return http({
    url: '/api/purchaseContractInvocie/reportInvoiceSummary',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-财务-收票汇总表-详情页
export function ticketCollectionDetails (page, size, id, data) {
  return http({
    url: `/api/purchaseContractInvocie/ticketCollectionDetails/${page}/${size}/${id}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-收票汇总表-详情页-导出
export function reportTicketCollectionDetails (id, data) {
  return http({
    url: `/api/purchaseContractInvocie/reportTicketCollectionDetails/${id}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-坏账明细
export function selectFinanceBadDebtList (page, size, data) {
  return http({
    url: `/api/financeBadDebt/selectFinanceBadDebtList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-坏账明细-导出
export function exportFinanceBadDebt (data) {
  return http({
    url: '/api/financeBadDebt/exportFinanceBadDebt',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-银行收款统计
export function queryFinanceBankReceiptList (page, size, data) {
  return http({
    url: `/api/finaceBankReceipt/queryFinanceBankReceiptList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-银行收款统计-导出
export function exprotFinanceBankReceiptList (data) {
  return http({
    url: '/api/finaceBankReceipt/exprotFinanceBankReceiptList',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-承兑汇票收款统计
export function queryFinanceBillStatistics (page, size, data) {
  return http({
    url: `/api/financeAcceptanceBill/queryFinanceBillStatistics/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-承兑汇票收款统计-导出
export function exprotFinanceBillStatistics (data) {
  return http({
    url: '/api/financeAcceptanceBill/exprotFinanceBillStatistics',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-承兑汇票付款统计
export function queryFinaceBillPayment (page, size, data) {
  return http({
    url: `/api/financePay/queryFinaceBillPayment/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-承兑汇票付款统计-导出
export function exportFinaceBillPayment (data) {
  return http({
    url: '/api/financePay/exportFinaceBillPayment',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-财务-银行付款统计
export function selectFinancePaySourceBankList (page, size, data) {
  return http({
    url: `/api/financePay/selectFinancePaySourceBankList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-财务-银行付款统计-导出
export function exportFinancePaySourceBankList (data) {
  return http({
    url: '/api/financePay/exportFinancePaySourceBankList',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购产品提醒
export function queryReportProductRemind (page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryReportProductRemind/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 数据报表-采购-采购产品提醒-导出
export function exportReportProductRemind (data) {
  return http({
    url: '/api/purchaseContractContent/exportReportProductRemind',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购询价报表
export function queryInquiryReport (page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryInquiryReport/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购询价报表-导出
export function exportInquiryReport (data) {
  return http({
    url: '/api/purchaseContractContent/exportInquiryReport',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购节约成本统计报表
export function queryReportCostSaving (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportCostSaving/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购节约成本统计报表-导出
export function exportReportCostSaving (data) {
  return http({
    url: '/api/purchaseContractBase/exportReportCostSaving',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购报缺明细
export function queryReportContractLack (page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryReportContractLack/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购报缺明细-导出
export function exportReportContractLack (data) {
  return http({
    url: '/api/purchaseContractContent/exportReportContractLack',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 根据部门id查询子角色和子部门
export function queryComOrganizationRoleByOrgId (orgId, data) {
  return http({
    url: `/api/comOrganization/queryComOrganizationRoleByOrgId/${orgId}`,
    method: 'get',
    data: data
  })
}

// 数据报表-采购-产品采购统计
export function queryReportProduct (page, size, data) {
  return http({
    url: `/api/purchaseContractContent/queryReportProduct/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-产品采购统计-导出
export function exportReportProduct (data) {
  return http({
    url: '/api/purchaseContractContent/exportReportProduct',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-产品采购统计-采购明细
export function queryReportProductDetail (page, size, proId, data) {
  return http({
    url: `/api/purchaseContractContent/queryReportProductDetail/${page}/${size}/${proId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购明细-导出
export function ReportProductDetail (proId, data) {
  return http({
    url: `/api/purchaseContractContent/ReportProductDetail/${proId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购日报表/采购月报表-详情日报表
export function queryReportPurchaseDay (page, size, flag, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportPurchaseDay/${page}/${size}/${flag}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购日报表-导出
export function exportReportPurchaseDay (flag, data) {
  return http({
    url: `/api/purchaseContractBase/exportReportPurchaseDay/${flag}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购日报表/采购月报表-详情日报表-查看采购合同产品详情
export function queryReportPurchaseContent (pcbId, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportPurchaseContent/${pcbId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购日报表-查看采购合同产品详情-导出
export function reportPurchaseContent (pcbId, data) {
  return http({
    url: `/api/purchaseContractBase/reportPurchaseContent/${pcbId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购月报表
export function queryReportPurchaseMonth (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportPurchaseMonth/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购月报表-导出
export function reportPurchaseMonth (data) {
  return http({
    url: '/api/purchaseContractBase/reportPurchaseMonth',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购月报表-详情日报表-导出
export function exportReportPurchaseDays (flag, data) {
  return http({
    url: `/api/purchaseContractBase/exportReportPurchaseDay/${flag}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-供应商供货统计
export function queryReportSupplier (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportSupplier/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-供应商供货统计-导出
export function reprotSupplier (data) {
  return http({
    url: '/api/purchaseContractBase/reprotSupplier',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-供应商供货统计-详情页
export function queryReportSupplierDetail (page, size, suId, data) {
  return http({
    url: `/api/purchaseContractBase/queryReportSupplierDetail/${page}/${size}/${suId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-供应商供货统计-详情页导出
export function reportSupplierDatail (suId, data) {
  return http({
    url: `/api/purchaseContractBase/reportSupplierDatail/${suId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购退货统计
export function queryReportReceipt (page, size, data) {
  return http({
    url: `/api/purchaseContractRetreat/queryReportReceipt/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购退货统计-导出
export function reportReceipt (data) {
  return http({
    url: '/api/purchaseContractRetreat/reportReceipt',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-采购-采购退货统计-详情页
export function queryReportReceiptDetails (page, size, pcrId, data) {
  return http({
    url: `/api/purchaseContractRetreat/queryReportReceiptDetails/${page}/${size}/${pcrId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-采购-采购退货统计-详情页导出
export function reportReceiptDetails (pcrId, data) {
  return http({
    url: `/api/purchaseContractRetreat/reportReceiptDetails/${pcrId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-销售发货表
export function queryDeliverGoods (page, size, data) {
  return http({
    url: `/api/orderContractDeliverGoods/queryDeliverGoods/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售发货表-导出
export function reportDeliverGoods (data) {
  return http({
    url: '/api/orderContractDeliverGoods/reportDeliverGoods',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-销售-销售业绩表
export function salesPerformance (page, size, data) {
  return http({
    url: `/api/orderContractContent/salesPerformance/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售业绩表-导出
export function reportSalesPerformance (data) {
  return http({
    url: '/api/orderContractContent/reportSalesPerformance',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-销售报缺明细
export function queryContractLackList (page, size, data) {
  return http({
    url: `/api/orderContractLack/queryContractLackList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售报缺明细-导出
export function reportContractLackList (data) {
  return http({
    url: '/api/orderContractLack/reportContractLackList',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-产品销售统计
export function queryOrderContractContentProList (page, size, data) {
  return http({
    url: `/api/orderContractContent/queryOrderContractContentProList/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-产品销售统计-导出
export function reportOrderContractContent (data) {
  return http({
    url: '/api/orderContractContent/reportOrderContractContent',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-销售-产品销售统计详情
export function queryOrderContractContentProListByOccId (proId, page, size, data) {
  return http({
    url: `/api/orderContractContent/queryOrderContractContentProListByOccId/${proId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-产品销售统计详情-导出
export function reportOrderContractContentProListByOccId (proId, data) {
  return http({
    url: `/api/orderContractContent/reportOrderContractContentProListByOccId/${proId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-销售退货统计
export function salesReturnStatistics (page, size, data) {
  return http({
    url: `/api/orderContractSaleReturnGoods/salesReturnStatistics/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售退货统计-导出
export function reportSalesReturnStatistics (data) {
  return http({
    url: '/api/orderContractSaleReturnGoods/reportSalesReturnStatistics',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-销售-销售退货统计详情
export function salesReturnStatisticsPro (ocsgId, data) {
  return http({
    url: `/api/orderContractSaleReturnGoods/salesReturnStatisticsPro/${ocsgId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售退货统计详情-导出
export function reportSalesReturnStatisticsPro (ocsgId, data) {
  return http({
    url: `/api/orderContractSaleReturnGoods/reportSalesReturnStatisticsPro/${ocsgId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-客户销售统计
export function queryCustomerSaleStatistic (page, size, data) {
  return http({
    url: `/api/orderContractBase/queryCustomerSaleStatistic/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-客户销售统计-导出
export function reportCustomerSaleStatistic (data) {
  return http({
    url: '/api/orderContractBase/reportCustomerSaleStatistic',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-销售-客户销售统计详情
export function queryCustomerSaleStatisticDetail (cusId, page, size, data) {
  return http({
    url: `/api/orderContractBase/queryCustomerSaleStatisticDetail/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-客户销售统计详情-导出
export function reportCustomerSaleStatisticDetail (cusId, data) {
  return http({
    url: `/api/orderContractBase/reportCustomerSaleStatisticDetail/${cusId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-销售日报表
export function querySalesDaily (page, size, type, data) {
  return http({
    url: `/api/orderContractContent/querySalesDaily/${page}/${size}/${type}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售日报表-导出
export function reportSalesDaily (type, data) {
  return http({
    url: `/api/orderContractContent/reportSalesDaily/${type}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 数据报表-销售-销售日报表详情
export function queryOrderContractProductDetails (ocbId, data) {
  return http({
    url: `/api/orderContractContent/queryOrderContractProductDetails/${ocbId}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售日报表详情-导出
export function reportOrderContractProductDetails (ocbId, data) {
  return http({
    url: `/api/orderContractContent/reportOrderContractProductDetails/${ocbId}`,
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售-销售月报表
export function orderContractMonth (page, size, data) {
  return http({
    url: `/api/orderContractContent/orderContractMonth/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 数据报表-销售-销售月报表-导出
export function reportOrderContractMonth (data) {
  return http({
    url: '/api/orderContractContent/reportOrderContractMonth',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 数据报表-销售日/月报-部门查询接口
export function querySalesDailyOrgName (data) {
  return http({
    url: '/api/orderContractContent/querySalesDailyOrgName',
    method: 'get',
    data
  })
}
// 数据报表-销售日/月报-根据部门id查询部门负责人接口
export function querySalesDailyUser (orgIds, data) {
  return http({
    url: '/api/orderContractContent/queryOrgIdsSalesDailyUser',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}

// 数据报表-采购日/月报-部门查询接口
export function queryPurchaseOrgName (data) {
  return http({
    url: '/api/purchaseContractBase/queryPurchaseOrgName',
    method: 'get',
    data
  })
}
// 数据报表-采购日/月报-根据部门id查询部门负责人接口
export function queryOrgIdsPurchase (orgIds, data) {
  return http({
    url: '/api/purchaseContractBase/queryOrgIdsPurchase',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}

// 数据报表-采购报缺明细-部门查询接口
export function queryContractLackOrgIds (data) {
  return http({
    url: '/api/orderContractLack/queryContractLackOrgIds',
    method: 'get',
    data
  })
}
// 数据报表-采购报缺明细-根据部门id查询部门负责人接口
export function queryOrgIdsContractLackUser (orgIds, data) {
  return http({
    url: '/api/orderContractLack/queryOrgIdsContractLackUser',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}

// 数据报表-产品销售统计-部门查询
export function queryOrderContractContentProListOrgIds (data) {
  return http({
    url: 'api/orderContractContent/queryOrderContractContentProList/org/list',
    method: 'get',
    data
  })
}
// 数据报表-产品销售统计-负责人查询
export function queryOrderContractContentProListUser (orgIds, data) {
  return http({
    url: 'api/orderContractContent/queryOrderContractContentProList/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-销售发货表-部门查询
export function queryDeliverGoodsOrgIds (data) {
  return http({
    url: '/api/orderContractDeliverGoods/queryDeliverGoods/org/list',
    method: 'get',
    data
  })
}
// 数据报表-销售发货表-负责人查询
export function queryDeliverGoodsUser (orgIds, data) {
  return http({
    url: '/api/orderContractDeliverGoods/queryDeliverGoods/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-销售退货统计-部门查询接口
export function salesReturnStatisticsOrgIds (data) {
  return http({
    url: '/api/orderContractSaleReturnGoods/salesReturnStatistics/org/list',
    method: 'get',
    data
  })
}
// 数据报表-销售退货统计-负责人查询
export function salesReturnStatisticsUser (orgIds, data) {
  return http({
    url: '/api/orderContractSaleReturnGoods/salesReturnStatistics/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}

// 数据报表-采购退货统计-部门查询
export function queryReportReceiptOrgIds (data) {
  return http({
    url: '/api/purchaseContractRetreat/queryReportReceipt/org/list',
    method: 'get',
    data
  })
}
// 数据报表-采购询价报表-部门查询
export function queryInquiryReportOrgIds (data) {
  return http({
    url: '/api/purchaseContractContent/queryInquiryReport/org/list',
    method: 'get',
    data
  })
}

// 数据报表-采购报缺明细-部门查询
export function queryReportContractLackOrgIds (data) {
  return http({
    url: '/api/purchaseContractContent/queryReportContractLack/org/list',
    method: 'get',
    data
  })
}

// 数据报表-产品采购统计-部门查询
export function queryReportProductOrgIds (data) {
  return http({
    url: '/api/purchaseContractContent/queryReportProduct/org/list',
    method: 'get',
    data
  })
}

// 数据报表-采购产品提醒报表-部门查询
export function queryReportProductRemindOrgIds (data) {
  return http({
    url: '/api/purchaseContractContent/queryReportProductRemind/org/list',
    method: 'get',
    data
  })
}

// 数据报表-采购节约成本统计报表-部门查询
export function queryReportCostSavingOrgIds (data) {
  return http({
    url: '/api/purchaseContractBase/queryReportCostSaving/org/list',
    method: 'get',
    data
  })
}

// 数据报表-采购退货统计-负责人查询
export function queryReportReceiptsUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractRetreat/queryReportReceipt/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-采购询价报表-负责人查询
export function queryInquiryReportUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractContent/queryInquiryReport/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-采购报缺明细-负责人查询
export function queryReportContractLackUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractContent/queryReportContractLack/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-产品采购统计-负责人查询
export function queryReportProductUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractContent/queryReportProduct/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-采购产品提醒报表-负责人查询
export function queryReportProductRemindUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractContent/queryReportProductRemind/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}
// 数据报表-采购节约成本统计报表-负责人查询
export function queryReportCostSavingUser (orgIds, data) {
  return http({
    url: '/api/purchaseContractBase/queryReportCostSaving/staff/list',
    method: 'get',
    data,
    params: {
      orgIds: orgIds
    }
  })
}

// 数据报表-贴现报表-部门查询接口
export function queryFinanceDiscountOrgName (data) {
  return http({
    url: '/api/financePay/queryFinanceDiscountOrgName',
    method: 'post',
    data
  })
}
